var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5v4c0 .28-.22.5-.5.5H7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h4v-3H4.5C2.02 18 0 15.98 0 13.5v-8C0 3.02 2.02 1 4.5 1h14C20.98 1 23 3.02 23 5.5v1c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1C22 3.57 20.43 2 18.5 2h-14C2.57 2 1 3.57 1 5.5v8C1 15.43 2.57 17 4.5 17h7c.28 0 .5.22.5.5m12-5v8c0 1.93-1.57 3.5-3.5 3.5h-3c-1.93 0-3.5-1.57-3.5-3.5v-8c0-1.93 1.57-3.5 3.5-3.5h3c1.93 0 3.5 1.57 3.5 3.5m-1 0a2.5 2.5 0 0 0-2.5-2.5h-3a2.5 2.5 0 0 0-2.5 2.5v8a2.5 2.5 0 0 0 2.5 2.5h3a2.5 2.5 0 0 0 2.5-2.5z"
  })));
};
export { SvgDevices as ReactComponent };
export default __webpack_public_path__ + "assets/images/devices.svg";